import { defineMessages } from 'react-intl';
/**
 * Internationalized messages for use on header.
 */
export default defineMessages({
  exploreProjects: {
    id: 'header.nav.projects',
    defaultMessage: 'Explore projects',
  },
  learn: {
    id: 'header.nav.learn',
    defaultMessage: 'Learn',
  },
  about: {
    id: 'header.nav.aboutLink',
    defaultMessage: 'About',
  },
  support: {
    id: 'header.nav.support',
    defaultMessage: 'Support',
  },
  myContributions: {
    id: 'header.nav.my_contributions',
    defaultMessage: 'My contributions',
  },
  manage: {
    id: 'header.nav.manage',
    defaultMessage: 'Manage',
  },
  logIn: {
    id: 'header.buttons.logIn',
    defaultMessage: 'Log in',
  },
  signUp: {
    id: 'header.buttons.signUp',
    defaultMessage: 'Sign up',
  },
  createAccount: {
    id: 'header.buttons.createAccount',
    defaultMessage: 'Create an account',
  },
  authorize: {
    id: 'header.buttons.authorize',
    defaultMessage: 'Log in',
  },
  AuthorizeTitle: {
    id: 'signUp.modal.authorize',
    defaultMessage: 'Have you finished the registration on OpenStreetMap?',
  },
  AuthorizeMessage: {
    id: 'signUp.authorize.message',
    defaultMessage:
      'Start mapping now! Just login to the Tasking Manager with your new OpenStreetMap account.',
  },
  osmRegisterCheck: {
    id: 'signUp.authorize.check',
    defaultMessage: 'Do you still need an OpenStreetMap account?',
  },
  signUpTitle: {
    id: 'signUp.modal.title',
    defaultMessage: 'Sign up',
  },
  signupLabelEmail: {
    id: 'signUp.modal.form_email',
    defaultMessage: 'Email',
  },
  signupLabelName: {
    id: 'signUp.modal.form_name',
    defaultMessage: 'Name',
  },
  proceedOSMTitle: {
    id: 'signUp.proceed_osm.osm_title',
    defaultMessage: 'Do you have an OpenStreetMap account?',
  },
  proceedOSMPart1: {
    id: 'signup.proceed_osm.text1',
    defaultMessage:
      'The Tasking Manager works with OpenStreetMap, a collaborative, open-source map of the world. Everything you map on the Tasking Manager is going to be available on OpenStreetMap.',
  },
  proceedOSMPart2: {
    id: 'signup.proceed_osm.text2',
    defaultMessage: "First, you'll need an account on OpenStreetMap.org in order to get started.",
  },
  proceedOSMLogin: {
    id: 'signup.proceed_osm.login',
    defaultMessage: 'I already have an OpenStreetMap account',
  },
  emailPlaceholder: {
    id: 'input.placeholder.email_address',
    defaultMessage: 'Your email address',
  },
  invalidEmail: {
    id: 'input.errors.email_address',
    defaultMessage: 'Invalid email address',
  },
  invalidName: {
    id: 'input.errors.name',
    defaultMessage: 'Invalid name',
  },
  namePlaceHolder: {
    id: 'input.placeholder.Name',
    defaultMessage: 'Your Name',
  },
  slogan: {
    id: 'header.topBar.slogan',
    defaultMessage: 'Mapping our world together',
  },
  settings: {
    id: 'header.nav.settings',
    defaultMessage: 'Settings',
  },
  myTeams: {
    id: 'header.nav.my_teams',
    defaultMessage: 'My teams',
  },
  logout: {
    id: 'header.nav.logout',
    defaultMessage: 'Logout',
  },
  email: {
    id: 'signup.modal.email',
    defaultMessage: 'Email',
  },
  submitProceed: {
    id: 'signup.button.submit',
    defaultMessage: 'Next',
  },
  submitProceedOSM: {
    id: 'signup.button.submit_osm',
    defaultMessage: 'Create OpenStreetMap account',
  },
  signUpQuestion: {
    id: 'signup.modal.question',
    defaultMessage: 'Please provide your name and email address:',
  },
  emailUpdateButton: {
    id: 'emailUpdate.modal.button',
    defaultMessage: 'Update',
  },
  emailUpdateSuccess: {
    id: 'emailUpdate.modal.success_message',
    defaultMessage: 'Email updated successfully',
  },
  emailUpdateTitle: {
    id: 'emailUpdate.modal.title',
    defaultMessage: 'Update your email',
  },
  emailUpdateTextPart1: {
    id: 'emailUpdate.modal.text1',
    defaultMessage: 'Before you begin mapping, please add your email address.',
  },
  emailUpdateTextPart2: {
    id: 'emailUpdate.modal.text2',
    defaultMessage:
      'We are mapping together! Providing your email address is necessary for mapping feedback and direct messages to reach you.',
  },
  privacyPolicy: {
    id: 'emailUpdate.modal.privacy_policy',
    defaultMessage:
      "Read our Privacy Policy for more information on how we protect users' personal data.",
  },
  newVersionAvailable: {
    id: 'serviceWorker.dialog.newVersion',
    defaultMessage: 'There is a new Tasking Manager version available!',
  },
  update: {
    id: 'serviceWorker.dialog.update',
    defaultMessage: 'Update now',
  },
  remindMeLater: {
    id: 'serviceWorker.dialog.remindMeLater',
    defaultMessage: 'Remind me later',
  },
});
